/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Camping',
  definitions: {
    '32': {
      viewBox: '0 0 32 32',
      path: (
        <>
          <path
            fillRule="evenodd"
            d="M18.861 3.335a.6.6 0 1 0-1.056-.571L16 6.105l-1.806-3.34a.6.6 0 1 0-1.056.571l2.179 4.032L3.976 28.35H2a.6.6 0 1 0 0 1.2h2.323.021 6.313 10.668 6.333.021H30a.6.6 0 1 0 0-1.2h-1.976L16.682 7.367l2.179-4.032zm2.83 25.015h4.969L16 8.629 5.34 28.35h4.969l5.163-9.552a.6.6 0 0 1 1.056 0l5.163 9.552zm-10.018 0h8.654L16 20.345l-4.327 8.005z"
            fill="currentColor"
          />
        </>
      ),
    },
    '48': {
      viewBox: '0 0 48 48',
      path: (
        <>
          <path
            fillRule="evenodd"
            d="M28.05 4.872c.164-.304.051-.683-.253-.847s-.683-.051-.847.253L24 9.735l-2.95-5.458c-.164-.304-.543-.417-.847-.253s-.417.543-.253.847l3.339 6.178L6.127 42.8H3c-.345 0-.625.28-.625.625s.28.625.625.625h3.486.027 9.477 16.001 9.496.027H45c.345 0 .625-.28.625-.625s-.28-.625-.625-.625h-3.127L24.711 11.05l3.339-6.178zM32.373 42.8h8.079L24 12.364 7.548 42.8h8.079l7.823-14.472c.109-.202.32-.328.55-.328s.441.126.55.328L32.373 42.8zm-15.324 0h13.903L24 29.939 17.048 42.8z"
            fill="currentColor"
          />
        </>
      ),
    },
    '64': {
      viewBox: '0 0 64 64',
      path: (
        <>
          <path
            fillRule="evenodd"
            d="M37.37 6.48a.8.8 0 0 0-1.407-.761L32 13.051 28.037 5.72a.8.8 0 1 0-1.407.761l4.461 8.253L8.19 57.1H4a.8.8 0 1 0 0 1.6h4.647.024 12.644.037 21.298.037 12.629.038H60a.8.8 0 1 0 0-1.6h-4.19L32.909 14.733 37.37 6.48zm5.774 50.62h10.848L32 16.415 10.008 57.1h10.848l10.44-19.314a.8.8 0 0 1 1.408 0L43.144 57.1zm-20.468 0h18.65L32 39.849 22.675 57.1z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
